import { render, staticRenderFns } from "./myFollowItem.vue?vue&type=template&id=db8314ae&scoped=true"
import script from "./myFollowItem.vue?vue&type=script&lang=js"
export * from "./myFollowItem.vue?vue&type=script&lang=js"
import style0 from "./myFollowItem.vue?vue&type=style&index=0&id=db8314ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db8314ae",
  null
  
)

export default component.exports